import { createSlice } from '@reduxjs/toolkit';

interface services {
    id: string | number,
    port: string,
    serviceName: string,
    displayName: string,
    components: string,
}

export interface servicesState {
    isServicesDataLoading: boolean;
    servicesData: Array<services>;
    servicesError: boolean;
}

const initialState: servicesState = {
    isServicesDataLoading: false,
    servicesData: [],
    servicesError: false,
}

const servicesReducer = createSlice({
    name: 'services',
    initialState: initialState,
    reducers: {
        getServicesDataRequest: (state, action: { payload: string }) => {
            state.isServicesDataLoading = true;
        },
        getServicesDataResponse: (state, action) => {
            state.isServicesDataLoading = false;
            state.servicesData = action.payload.res;
        },
        getServicesDataFailed: (state) => {
            state.isServicesDataLoading = false;
            state.servicesError = true;
        }}
    })


export const servicesActions = servicesReducer.actions;
export default servicesReducer;